import { getBearerToken, getSegments } from "../../services/SegmentToolsMenu.service";

export class SegmentToolsMenu {
    private segments: any = [];
    private token = "";

    public initializeSegmentToolsMenu(): void {
        if (this.isLocalDevelopmentEnvironment()) {
            document.getElementById("segment-tools-container").style.removeProperty("display");

            this.registerLoginButtonClickHandler();
            this.registerLoadSegmentButtonClickHandler();
            this.registerLoadWorkderButtonClickHandler();
            this.loadSessionState();
            return;
        }

        document.getElementById("segment-tools-container").remove();
    }

    private isLocalDevelopmentEnvironment(): boolean {
        const hostName = window.location.hostname;

        return hostName === "localhost";
    }

    private registerLoginButtonClickHandler(): void {
        let loginButton = document.getElementById("login-button");

        loginButton.addEventListener("click", () => {
            getBearerToken()
                .then(response => {
                    sessionStorage.api = (<HTMLSelectElement>(document.getElementById("api"))).value;

                    this.token = response["access_token"];
                    return getSegments(this.token);
                })
                .then(response => {
                    this.segments = response;

                    this.populateSegmentDropdown(response);
                })
                .catch(error => console.error(error));
        });
    }

    private populateSegmentDropdown(segments: any[]): void {
        let segmentDropdown = <HTMLSelectElement>(document.getElementById("segment"));
        segmentDropdown.innerText = null;

        let defaultOption = document.createElement("option");
        defaultOption.text = "Select Segment";

        segmentDropdown.add(defaultOption);

        for (let i = 0; i < segments.length; i++) {
            let option = document.createElement("option");
            option.text = segments[i]["name"];
            option.value = i.toString();

            segmentDropdown.add(option);
        }
    }

    private registerLoadSegmentButtonClickHandler(): void {
        let loadSegmentButton = document.getElementById("load-segment");

        loadSegmentButton.addEventListener("click", () => {
            const segmentIndex = +((<HTMLSelectElement>(document.getElementById("segment"))).value);
            const customerName = (<HTMLInputElement>document.getElementById("siteCode")).value;
            const segmentId = this.segments[segmentIndex]["id"];
            const customerId = this.segments[segmentIndex]["customerId"];
            const apiGateway = (<HTMLSelectElement>(document.getElementById("api"))).value;

            this.saveSessionState(customerName, segmentIndex);
            this.loadSegment(segmentId, customerName, customerId, apiGateway);
        });
    }

    private saveSessionState(customerName: string, segmentIndex: number): void {
        sessionStorage.token = this.token;
        sessionStorage.segments = JSON.stringify(this.segments);
        sessionStorage.sitecode = customerName;
        sessionStorage.username = (<HTMLInputElement>document.getElementById("username")).value;
        sessionStorage.password = (<HTMLInputElement>document.getElementById("password")).value;
        sessionStorage.selectedSegment = segmentIndex;
        sessionStorage.showAssetIcons = (<HTMLInputElement>(document.getElementById("showAssetIcons"))).checked;
    }

    private loadSegment(segmentId: number, customerName: string, customerId: number, apiGateway: string): void {
        let cmsViewUrl = `http://localhost:8080/index.html?parent_app=cms_tech&token=${this.token}&api_gateway=${apiGateway}&segmentid=${segmentId}&customername=${customerName}&customerid=${customerId}#`;

        const showAssetIconsChecked = (<HTMLInputElement>(document.getElementById("showAssetIcons"))).checked;

        if (showAssetIconsChecked) {
            cmsViewUrl.slice(0, -1);
            cmsViewUrl += "&woasseticons=true";
        }

        window.location.href = cmsViewUrl;
    }

    private registerLoadWorkderButtonClickHandler(): void {
        let loadWorkorderButton = document.getElementById("load-workorders");

        loadWorkorderButton.addEventListener("click", () => {
            (window as any).dispatchWorkorderQuery(
                {
                    "CMSStatuses": [1, 2],
                    "AssignedToUser": "true",
                    "Properties": {
                        "IncludeCollectionIDs": [1, 2, 3, 4],
                        "SortField": "number",
                        "PageSize": 5000,
                        "ViewObject":
                        {
                            "Properties": {}
                        }
                    }
                }
            );
        });
    }

    private loadSessionState(): void {
        if (sessionStorage.token) {
            const parsedSegments = JSON.parse(sessionStorage.segments);

            this.segments = parsedSegments;
            this.populateSegmentDropdown(parsedSegments);
            this.token = sessionStorage.token;

            (<HTMLInputElement>document.getElementById("username")).value = sessionStorage.username;
            (<HTMLInputElement>document.getElementById("password")).value = sessionStorage.password;
            (<HTMLInputElement>document.getElementById("siteCode")).value = sessionStorage.sitecode;
            (<HTMLSelectElement>(document.getElementById("segment"))).value = sessionStorage.selectedSegment;
            (<HTMLSelectElement>(document.getElementById("api"))).value = sessionStorage.api;
            (<HTMLInputElement>(document.getElementById("showAssetIcons"))).checked = sessionStorage.showAssetIcons;
        }
    }
}